const cryptoJS = require("crypto-js");

const encrypt = (text: string) => {
  try {
    return cryptoJS.enc.Base64.stringify(cryptoJS.enc.Utf8.parse(text));
  } catch (error) {
    throw error;
  }
};

const decrypt = (data: string) => {
  try {
    if (!data || typeof data !== "string") {
      throw new Error("Invalid input");
    }

    const decoded = cryptoJS.enc.Base64.parse(data);
    const result = decoded.toString(cryptoJS.enc.Utf8);

    if (!result) {
      throw new Error("Invalid Base64 string");
    }

    return result;
  } catch (error) {
    console.error("Decrypt failed:", error);
    throw error;
  }
};

export const EncryptionService = { encrypt, decrypt };
